import { property } from '@wonderlandengine/api/decorators.js';
import { Component, Material } from '@wonderlandengine/api';

/**
 * Dashboard Face Description:
 */
export class DashFaceDescription extends Component {
	static TypeName = 'dash-face-description';

	//-----------------------------------------------------------------------------------------
	// Inspector Variables:
	//-----------------------------------------------------------------------------------------

	@property.string('')
	dashboardId: string = '';

	@property.material()
	dashboardMaterial: Material | null = null;
}